import Vue from 'vue';
import VueMq from 'vue-mq';
import Vue2TouchEvents from 'vue2-touch-events';

import components from './components/index.js';
import store from './store/index.js';
import { ucfirst, upcase, unhandleize } from './filters/string.js';
import { money, moneyWithoutDecimals } from './filters/money.js';
import render from './helpers/module.js';

__webpack_public_path__ = window.__webpack_public_path__; // eslint-disable-line no-underscore-dangle, camelcase

const cssVars = require('../styles/variables.scss');
/**
 * We need to re-render these Vue components because the theme.js sometimes outputs the DOM by fetching a section
 * via Shopify endpoints and doing a .innerHTML on certain elements, therefore, Vue components are outputted in plain HTML.
 */
const eventsToReRender = [
  {
    eventName: 'recommendations-loaded',
    componentsToReRender: ['ProductCard', 'Icon']
  },
  {
    eventName: 'collection-filtered',
    componentsToReRender: ['ProductCard']
  },
  {
    eventName: 'cart-page-item-updated',
    componentsToReRender: ['CartRemoveLink']
  }
];

Vue.config.productionTip = false;

Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(cssVars.breakTablet, 10),
    tablet: parseInt(cssVars.breakDesktop, 10),
    desktop: parseInt(cssVars.breakHd, 10),
    hd: Infinity,
  },
});
Vue.use(Vue2TouchEvents);

Vue.filter('ucfirst', ucfirst);
Vue.filter('upcase', upcase);
Vue.filter('unhandleize', unhandleize);
Vue.filter('money', money);
Vue.filter('moneyWithoutDecimals', moneyWithoutDecimals);

const vueWindow = { ...window };
Vue.prototype.$window = vueWindow;

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // check that click was outside the element
      if (!(el === event.target || el.contains(event.target))) {
        // if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

window.addEventListener('DOMContentLoaded', () => {
  const vueRoots = document.querySelectorAll('[data-vue-root]');

  vueRoots.forEach((root) => {
    render({
      root,
      component: new Vue({ store }),
      is: components[root.dataset.vueRoot],
    });
  });
});

/**
 * We listen for custom events that are being created within the theme.js file, when these are triggered then we trigger the re-render
 * of the specified components.
 */
eventsToReRender.forEach((event) => {
  document.addEventListener(event.eventName, () => {
    const vueRoots = document.querySelectorAll('[data-vue-root]');

    vueRoots.forEach((root) => {
      if (event.componentsToReRender.includes(root.dataset.vueRoot)) {
        render({
          root,
          component: new Vue({ store }),
          is: components[root.dataset.vueRoot],
        });
      }
    });
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const sectionContainer = document.getElementById(event.target.id);
  const NewComponent = Vue.extend({
    components,
    template: event.target.innerHTML,
  });
  const component = new NewComponent({ store }).$mount();

  sectionContainer.innerHTML = '';
  sectionContainer.appendChild(component.$el);
  window.dispatchEvent(new Event('resize'));
});
